import React, { createContext, useContext, useEffect } from "react";
import { useEventBus } from "@/features/tutor/hooks/useEventBus";
import { useClock } from "@/features/tutor/hooks/useClock";
import { useRef } from "react";

// Minimal shape of the PCMPlayer fields useCaptionsQueue/usePlayerTick need.
type PcmPlayerHandle = {
  audioCtx?: AudioContext;
  startTime?: number;
  playedMs?: number;
  silentGapMs?: number;
  audioT0?: number | null;
  tickPlayedMs?: () => number;
  volume?: (value: number) => void;
  isPlaying?: () => boolean;
};

const RuntimeContext = createContext<any>(undefined);

export const RuntimeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const bus = useEventBus();
  const clock = useClock();
  const inactivityRef = useRef(null);
  // Shared by whichever pipeline owns the active TTS player (tutor's
  // useAudioPlayer or spaces' useSpaceAgent).
  const pcmPlayerRef = useRef<PcmPlayerHandle | null>(null);
  useEffect(() => {
    return () => {
      if (inactivityRef.current) {
        clearTimeout(inactivityRef.current);
      }
    };
  }, []);
  return (
    <RuntimeContext.Provider
      value={{ ...bus, ...clock, inactivityRef, pcmPlayerRef }}
    >
      {children}
    </RuntimeContext.Provider>
  );
};

export const useRuntimeContext = () => useContext(RuntimeContext);
